import { render, staticRenderFns } from "./wxMessage.vue?vue&type=template&id=e8c4c458&scoped=true&"
import script from "./wxMessage.vue?vue&type=script&lang=ts&"
export * from "./wxMessage.vue?vue&type=script&lang=ts&"
import style0 from "./wxMessage.vue?vue&type=style&index=0&id=e8c4c458&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c4c458",
  null
  
)

export default component.exports